var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArIq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hinava_random_uuid_243823618030643691131649993905756417918)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_131721671944687133932509369777998495803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_131721671944687133932509369777998495803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9 0H33V24H-9V0Z",
    fill: "#CD1125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 8H33V16H-9V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 16H33V24H-9V16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6054 10.3796C15.5454 10.3496 15.4854 10.3197 15.4854 10.2897C15.4554 10.2597 15.4854 10.2597 15.6054 10.2897C15.8153 10.3496 15.9652 10.3197 16.1152 10.1997L16.2351 10.0798L16.3851 10.1397L16.565 10.1997C16.625 10.1697 16.7749 10.0198 16.7449 9.9598C16.7449 9.89982 16.8049 9.89982 16.8349 9.98979C16.8949 10.1397 16.8049 10.3197 16.655 10.3496C16.595 10.3796 16.505 10.3496 16.4151 10.3197C16.2651 10.2597 16.2651 10.2597 16.1751 10.3197C16.0252 10.4696 15.8153 10.4696 15.6054 10.3796Z",
    fill: "#017B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1452 9.86983C16.0852 9.80986 16.0252 9.53997 16.0552 9.47999C16.0852 9.42001 16.0852 9.42001 16.1452 9.42001C16.2351 9.45 16.2651 9.50998 16.2351 9.71989C16.2351 9.89982 16.2052 9.92981 16.1452 9.86983Z",
    fill: "#017B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7277 9.68991C9.69772 9.80986 9.93762 10.1397 10.0576 10.1697C9.9976 10.1997 9.90763 10.1997 9.81767 10.2297C9.42782 10.6195 8.07837 11.939 7.80847 12.2689C8.55817 12.2689 9.36785 12.2689 10.0576 12.2389C10.0576 11.7291 10.5374 11.6991 10.8672 11.5192C11.0172 11.7891 11.437 11.7591 11.497 12.1489V13.8283H5.13954C5.04958 14.3081 4.62975 14.6979 4 14.548C4.17993 14.338 4.5098 14.2781 4.62975 14.0082C4.71971 13.4084 4.41983 13.0186 4.2399 12.6887C4.53978 12.5688 4.59976 12.5388 4.92963 12.3289C4.71971 13.0186 5.4994 12.9286 6.09916 12.9286C6.12915 12.6887 6.09916 12.4188 5.91923 12.3888C6.15913 12.2989 6.18912 12.2689 6.54898 11.969V12.8686H10.9572C10.9572 12.5688 11.0472 12.1189 10.8073 12.1189C10.5974 12.1189 10.8073 12.7187 10.6273 12.7187H7.2387V12.1489L8.34826 11.0394C8.43822 10.8894 9.12794 10.2597 9.7277 9.68991Z",
    fill: "#017B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2142 9.65991C18.4541 9.77986 18.6341 9.95979 18.9339 10.0498C18.904 10.1697 18.784 10.2297 18.754 10.3496V12.8986C19.0839 12.9586 19.1439 12.7787 19.2938 12.6887C19.3238 13.1085 19.5937 13.4984 19.5937 13.8282H18.2142V9.65991Z",
    fill: "#017B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.355 11.0394C16.355 11.0394 16.8648 10.6195 16.8648 10.5895V12.8386H17.2247V10.3196C17.3746 10.1697 17.6745 9.95978 17.7345 9.80984V13.8282H14.5558C14.4958 12.9886 14.4958 12.1489 15.4554 12.3288V11.999C15.4254 11.939 15.3654 11.999 15.3654 11.939C15.5154 11.7891 15.5754 11.7591 15.9952 11.3692V12.8386H16.355V11.0394ZM15.1555 12.8086C15.2155 12.8986 15.4554 12.8986 15.4554 12.7487C15.4254 12.5987 15.1255 12.6587 15.1555 12.8086Z",
    fill: "#017B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94922 14.488C6.04859 14.488 6.12914 14.4074 6.12914 14.308C6.12914 14.2087 6.04859 14.1281 5.94922 14.1281C5.84984 14.1281 5.76929 14.2087 5.76929 14.308C5.76929 14.4074 5.84984 14.488 5.94922 14.488Z",
    fill: "#017B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9468 9.65991C12.1867 9.77986 12.3666 9.95979 12.6665 10.0498C12.6365 10.1697 12.5165 10.2297 12.4866 10.3496V12.8986C12.8164 12.9586 12.8764 12.7787 13.0263 12.6887C13.0563 13.1085 13.3262 13.4984 13.3262 13.8282H11.9468V9.65991Z",
    fill: "#017B3D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hinava_random_uuid_243823618030643691131649993905756417918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArIq);
export default __webpack_public_path__ + "static/media/ar-IQ.f1fb5d1c7383c54c777c4a5f85fcbdda.svg";
export { ForwardRef as ReactComponent };